import cn from 'classnames';
import { GroupBase, OptionProps, SelectComponentsConfig, components as ReactSelectComponents } from 'react-select';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  selectedOptionClassName?: string,
  optionClassName?: string,
  ownProps: OptionProps<SOption, IsMulti, Group>,
}

const Option = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  components = {},
  selectedOptionClassName,
  optionClassName,
  ownProps: { children, ...otherProps },
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }_option`;
  const { isSelected, isDisabled, className } = otherProps;
  const optionClasses = cn(
    'Select-menu-list-option',
    className,
    {
      'is-selected': isSelected,
      'is-disabled': isDisabled,
      [selectedOptionClassName]: selectedOptionClassName && isSelected,
    },
  );

  if (components?.Option) {
    const { Option: OptionComponent } = components;

    return (
      <span
        data-test={ dataTestAttr }
        className={ optionClasses }
      >
        <OptionComponent { ...otherProps }>{ children }</OptionComponent>
      </span>
    );
  }

  return (
    <span data-test={ dataTestAttr } className={ optionClasses }>
      <ReactSelectComponents.Option { ...otherProps } className={ optionClassName }>
        { children }
      </ReactSelectComponents.Option>
    </span>
  );
};

export default Option;
